import kidsImage from '../../images/kids.png'
import droneImage from '../../images/droneshow.png'
import kidsVideo from '../../images/bottom-right.mp4'
import droneVideo from '../../images/top-left.mp4'

export const Hero2025 = () => {
  return (
    <>
      <div class="relative z-10 mx-auto max-w-7xl bg-white xl:px-8 ">
        <main className="bg-white">
          <div className="relative mx-auto h-auto w-full max-w-[--container-max-w] px-[--container-p] [--container-max-w:theme(maxWidth.4xl)] [--container-p:theme(spacing.6)] sm:mb-0 sm:[--container-p:theme(spacing.12)] lg:[--container-max-w:theme(maxWidth.5xl)] 2xl:[--container-max-w:theme(maxWidth.7xl)]">
            <div className="grid grid-cols-3 grid-rows-[auto,auto] sm:grid-cols-3 sm:grid-rows-2 ">
              <div className="relative col-span-2 col-start-2 h-48 w-full overflow-hidden object-cover sm:h-[28rem]">
                {/* <img
                  src={droneImage}
                  alt=""
                  className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 scale-105 object-cover"
                /> */}
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover"
                >
                  <source src={droneVideo} type="video/mp4" />
                </video>
              </div>
              {/* <img
                src={kidsImage}
                alt=""
                className="row-start-3 h-48 w-full object-cover sm:col-start-1 sm:row-start-2 sm:h-[28rem]"
              /> */}
              <video
                autoPlay
                loop
                muted
                playsInline
                className="col-start-1 row-start-2 h-full w-full object-cover sm:h-[28rem]"
              >
                <source src={kidsVideo} type="video/mp4" />
              </video>

              <div className="col-span-2 col-start-2 row-start-2 flex flex-col justify-center sm:justify-start sm:pr-8">
                <h1 className="p-4 font-condensed text-7xl font-bold uppercase leading-[.85em] text-[#060C52] sm:text-[112px] md:text-[144px]">
                  Lift
                  <br className="block" />
                  <span className="sm:tracking-[0.07em]">off</span>
                </h1>
                <p className="ml-4 hidden max-w-[43ch] pb-4 font-display tracking-tight text-[#9D908C] min-[400px]:block min-[400px]:pr-4 md:text-xl">
                  From the classroom to the cosmos, our students are pushing the
                  boundaries of possibility. Public education is the catalyst
                  from which our future is born.
                </p>
              </div>
            </div>

            {/* <div className="hidden w-full before:absolute before:right-full before:top-0 before:h-1/2 before:w-[calc(calc(calc(theme(width.screen)-var(--container-max-w))/2)+var(--container-p))] before:min-w-[--container-p] before:bg-[#050721] after:absolute after:left-full after:top-1/2 after:h-1/2 after:w-[calc(calc(calc(theme(width.screen)-var(--container-max-w))/2)+var(--container-p))] after:min-w-[--container-p] after:bg-[#050721] sm:inline-block"></div> */}
          </div>
        </main>
      </div>
      <div class="relative z-10 mx-auto max-w-7xl bg-white min-[400px]:mb-24 sm:mb-0 xl:px-8">
        <main className="bg-white">
          <div className="relative mx-auto h-auto w-full max-w-[--container-max-w] px-[--container-p] [--container-max-w:theme(maxWidth.4xl)] [--container-p:theme(spacing.6)] sm:[--container-p:theme(spacing.12)] lg:[--container-max-w:theme(maxWidth.5xl)] 2xl:[--container-max-w:theme(maxWidth.7xl)]"></div>
          <div className="grid grid-cols-6">
            <div className="col-span-4 col-start-3 flex h-12 items-center justify-center bg-neutral-100 sm:col-span-1 sm:col-start-3 sm:aspect-video sm:h-auto"></div>
          </div>
        </main>
      </div>
      <div className="col-span-3 row-start-3 flex items-center justify-center p-4 py-8 min-[400px]:hidden">
        <p className="ml-4 max-w-[43ch] pr-4 text-center font-display text-sm tracking-tight text-[#9D908C] md:text-xl">
          From the classroom to the cosmos, our students are pushing the
          boundaries of possibility. Public education is the catalyst from which
          our future is born.
        </p>
      </div>
    </>
  )
}
